"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_redux_1 = require("react-redux");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const AssetComment_1 = __importDefault(require("./AssetComment"));
const comment_constants_1 = __importDefault(require("./comment-constants"));
const helper_1 = require("../../helper");
const CommentsComponent = (props) => {
    const { comments, jobId, asset } = props;
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const [assetComments, setAssetComments] = (0, react_1.useState)([
        ...comments,
    ]);
    const getZiflowActivityNote = (activity) => {
        switch (activity.notes) {
            case comment_constants_1.default.PROOF_OPENED:
                return 'opened the proof.';
            case comment_constants_1.default.PROOF_COMMENT_ADDED:
                return 'added a comment to the proof.';
            case comment_constants_1.default.PROOF_COMMENT_CHANGED:
                return 'edited a comment to the proof.';
            case comment_constants_1.default.PROOF_COMMENT_DELETED:
                return 'deleted a comment from the proof.';
            case comment_constants_1.default.PROOF_DECISIONS:
                return 'made a decision.';
            case comment_constants_1.default.PROOF_UPDATED:
                return 'updated the proof.';
            case comment_constants_1.default.PROOF_REPLY_ADDED:
                return 'replied to a comment on the proof.';
            case comment_constants_1.default.PROOF_REPLY_CHANGED:
                return 'edited a reply on the proof.';
            case comment_constants_1.default.PROOF_REPLY_DELETED:
                return 'deleted a reply on the proof.';
            case comment_constants_1.default.PROOF_STATUS_CHANGED:
                return 'changed the status of the proof to status';
            case comment_constants_1.default.PROOF_REVIEW_COMPLETED:
                return 'completed the proof.';
            case comment_constants_1.default.PROOF_MENTIONS:
                return 'mentioned the proof.';
            case comment_constants_1.default.PROOF_STAGE_STARTED:
                return 'started stage on the review.';
            case comment_constants_1.default.PROOF_PROCESSED:
                return 'Proof processed.';
            case comment_constants_1.default.PROOF_CREATED:
                return 'created a new proof.';
            case comment_constants_1.default.PROOF_NEW_VERSION_CREATED:
                return 'created a new proof version.';
            case comment_constants_1.default.PROOF_FAILED:
                return 'Failed to create proof on ZiFlow';
            case comment_constants_1.default.PROOF_DELETED:
                return 'cancelled the proof';
            default:
                return 'changed ST on the review.';
        }
    };
    (0, react_1.useEffect)(() => {
        const listComments = comments
            .filter((comment) => {
            return comment.userId;
        })
            .map((item) => {
            return {
                ...item,
                date: (0, moment_1.default)(item.date, 'YYYY-MM-DD hh:mm aZ')
                    .tz(helper_1.USER_TIMEZONE)
                    .format('DD/MM/YYYY hh:mma'),
                notes: item.type !== 'review-activity-history'
                    ? item.notes
                    : getZiflowActivityNote(item),
            };
        });
        setAssetComments(listComments);
    }, [comments]);
    const handleOpenEditor = (id) => {
        const listActivity = assetComments.map((item) => {
            return item.noteId === id ? { ...item, isReply: !item.isReply } : item;
        });
        setAssetComments(listActivity);
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['comments--root'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['comments__header--ctn'] },
            react_1.default.createElement("label", { className: styles_modules_less_1.default['comments__header--label'] },
                "Round ", reviewRound === null || reviewRound === void 0 ? void 0 :
                reviewRound.roundNumber,
                " Activity")),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['comments--ctn'] }, assetComments.map((comment) => {
            return (react_1.default.createElement(AssetComment_1.default, { key: comment.noteId, comment: comment, handleOpenCommentReply: handleOpenEditor, jobId: jobId, asset: asset }));
        }))));
};
exports.default = CommentsComponent;
